export const useStoryblokContent = async (options?: {
  path?: string;
  resolve_relations?: string[];
}): Promise<{ story: any; blok: any; metadata: any }> => {
  const { path: routePath } = useRoute();
  const path =
    options?.path || (routePath == "/" ? "home" : routePath.replace("/", ""));

  const storyblokVersion = useRuntimeConfig().public.storyblokVersion as
    | "draft"
    | "published"
    | undefined;

  const blok = ref();
  const metadata = ref();

  const story = await useAsyncStoryblok(path, {
    version: storyblokVersion,
    resolve_links: "url",
    resolve_relations: options?.resolve_relations,
    resolve_links_level: 2,
  })
    .then((story) => {
      blok.value = story.value.content;

      if (blok.value?.metadata?.[0]) {
        metadata.value = blok.value?.metadata?.[0];

        pageHead(metadata.value);
      }

      return story;
    })
    .catch(() => {
      throw createError({
        statusCode: 404,
        statusMessage: `Storyblok page not found: "${path}"`,
        fatal: true,
      });
    });

  return {
    story,
    blok,
    metadata,
  };
};
